import CodeSegmentsViewModel from "@/components/screens/Login/Models/CodeSegmentsViewModel";
import type { ICodeSegmentsProps } from "@/components/screens/Login/Types/LoginTypes";
import { cn } from "@/utils/css";
import { Fragment } from "react";

const CodeSegments = (props: ICodeSegmentsProps) => {
  const { ariaLabel, autoFocus } = props;
  const vm = CodeSegmentsViewModel(props);

  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className="flex w-full items-center justify-center gap-[3px] sm:gap-1"
    >
      {vm.cells.map((char, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: cells are fixed positional slots; index is the stable identity
        <Fragment key={index}>
          <input
            ref={(cell) => {
              vm.cellRefs.current[index] = cell;
            }}
            type="text"
            inputMode="text"
            autoComplete="off"
            maxLength={1}
            // biome-ignore lint/a11y/noAutofocus: focusing the first empty cell on open is the intended OTP entry UX
            autoFocus={Boolean(autoFocus) && index === 0}
            aria-label={`${ariaLabel} character ${index + 1}`}
            value={char}
            onChange={(event) => vm.onCellChange(index, event.target.value)}
            onKeyDown={(event) => vm.onCellKeyDown(index, event)}
            onPaste={(event) => vm.onCellPaste(index, event)}
            onFocus={vm.onCellFocus}
            className={cn(
              "h-12 min-w-0 flex-1 rounded-lg border bg-white/10 px-0 text-center",
              "!text-white font-bold text-lg uppercase leading-none caret-dines-green",
              "focus:border-dines-green focus:outline-none focus:ring-2 focus:ring-dines-green/40",
              char ? "border-dines-green/70" : "border-white/20",
            )}
          />
          {vm.hasSeparatorAfter(index) && (
            <span aria-hidden="true" className="text-white/40">
              -
            </span>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default CodeSegments;
